import React, { Component } from "react";
import "./App.css";
import Navbar from "./components/navbar.js";
import LatestProject from "./components/latestproject.js";
import imageData from "./data/imagedata.js";
import latestProjectData from "./data/projectdata.js";
import { Switch, BrowserRouter, Route, Link } from "react-router-dom";
import About from "./components/about.js";
import Gallery from "./components/gallery.js";

class App extends Component {
  constructor(props) {
    super(props);
    var imageList = initGallery("All");
    var designList = initGallery("Design");
    var artworkList = initGallery("Artwork");
    this.state = {
      currentPage: "home",
      imageList: imageList,
      designList: designList,
      artworkList: artworkList,
      latestProjectData: latestProjectData
    };
  }

  render() {
    return (
      <div className="stretch">
        <div className="container-fluid" id="container-stickyfooter">
          <div id="body-stickyfooter">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-3">
                  <div id="masthead">
                    <h1>Marissa Conner</h1>
                    <p>UX Designer</p>
                  </div>

                  <header id="header">
                    <Navbar />
                  </header>
                </div>
                <div className="col-md-9">
                  <BrowserRouter>
                    <Switch>
                      <Route exact path="/">
                        <div>
                          <div className="row latestproject">
                            <LatestProject
                              latestProject={this.state.latestProjectData}
                              openModal={this.openModal}
                            />
                          </div>
                          <Gallery imageList={this.state.imageList} />
                        </div>
                      </Route>
                      <Route path="/portfolio">
                          <div>
                          <div className="row latestproject">
                            <LatestProject
                              latestProject={this.state.latestProjectData}
                              openModal={this.openModal}
                            />
                          </div>
                          <Gallery imageList={this.state.imageList} />
                        </div>
                      </Route>
                      <Route path="/artwork">
                        <Gallery imageList={this.state.artworkList} />
                      </Route>
                      <Route path="/design">
                        <Gallery imageList={this.state.designList} />
                      </Route>
                      <Route path="/about" component={About} />
                    </Switch>
                  </BrowserRouter>
                </div>
              </div>
            </div>
          </div>
          <footer id="footer-stickyfooter">
            Copyright &copy; Marissa Conner. All rights reserved.
          </footer>
        </div>
      </div>
    );
  }
}

function initGallery(filter) {
  console.log("Running initGallery with filter " + filter);
  var imageList = [];
  if( filter === 'All'){
    imageList = imageData.digital.galleryItems;
    for( var i = 0; i < imageList.length; i++){
      imageList[i].imageid = 'digital';
      imageList[i].imageindex = i;
    }
  }
  else {
    imageList = imageData.painting.galleryItems;
    for( var i = 0; i < imageList.length; i++){
      imageList[i].imageid = 'painting';
      imageList[i].imageindex = i;
    }
  }
  return imageList;
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js